import {Component, Input, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {FeatureType} from 'src/app/models/EnumTypes';
import {NavaidModel} from 'src/app/models/navaid';
import {ModalControlService} from 'src/app/services/modal-control.service';
import {PointsService} from 'src/app/services/points.service';
import {ProjectService} from 'src/app/services/project.service';
import * as fileSaver from 'file-saver';
import {NavaidControlService} from 'src/app/services/navaid-control.service';
import {ModalConfirmationService} from 'src/app/services/modal-confirmation.service';
import {HttpClient} from '@angular/common/http';
import {EndpointsService} from 'src/app/services/endpoints.service';
import {Feature} from 'ol';
import {NavaidsService} from 'src/app/services/navaids.service';
import {GritDeviceService} from "../../services/grit/grit.device.service";
import {GritReceiverService} from "../../services/grit/grit.receiver.service";
import {DeviceModel, InterferenceTestDeviceModel} from "../../models/grit/grit.device-model";

@Component({
  selector: 'app-export',
  templateUrl: './export.component.html',
  styleUrls: ['../../app.component.scss', './export.component.scss'],
  standalone: false
})
export class ExportComponent implements OnInit {

  @Input() entity : string;

  @Input() optionsToDisplay : string[];

  constructor(public bsModalRef : BsModalRef,
    private projectService : ProjectService,
    private pointsController: PointsService,
    private modalService : ModalControlService,
    private navaidService: NavaidControlService,
    private navaidsService: NavaidsService,
    private modalConfirmationMessage: ModalConfirmationService,
    private http: HttpClient,
    private endpointService: EndpointsService,
    protected deviceService : GritDeviceService,
    protected receiverService : GritReceiverService,
    )

    { }

  ngOnInit(): void {
  }
  exportNavaids(option: string, includeNavaidFiles: boolean){
    if(option == 'Selected Navaids to XML'){
      this.exportSelectedNavaidsToXml(includeNavaidFiles);
     }
     if(option == 'All Navaids to XML'){
       this.exportAllNavaidsToXml(includeNavaidFiles);
      }
     if(option == 'All Navaids to CSV'){
       this.navaidService.getAllCSVNavaids(includeNavaidFiles)
     }
     if(option == 'Selected Navaids to CSV'){
       this.navaidService.getSelectedCSVNavaids(includeNavaidFiles)
     }
     if(option == 'All Navaids to Safire'){
      this.exportNavaidsToSafire(this.pointsController.getAllNavaidsFeaturesFromLayers());
     }
     if(option == 'Selected Navaids to Safire'){
      this.exportNavaidsToSafire(this.pointsController.getSelectedFeaturesOfType(FeatureType.Navaid));
     }
  }
  exportNavaidsToSafire(features: Feature[]){
    let navaids: NavaidModel[] = [];
    for(let feature of features){
      const navaid:NavaidModel = this.pointsController.transformFeatureInNavaid(feature);
      const navaidPayload: NavaidModel =  this.navaidsService.getNavaidPayload(navaid);
      navaids.push(navaidPayload);
    }
    this.navaidService.exportNavaidsToSafireRequest(navaids);
  }

  async exportFile(option : string){
    // TODO: ADD the other entities
    switch(this.entity){
      case 'NavAids':
        if(option.endsWith('Safire')){
          this.exportNavaids(option,false);
        }
        else{
          this.modalConfirmationMessage.showMesssageConfirmationModal('Navaid Files Confirmation','Do you want to export associated files as well?','Yes','No',
          ()=> this.exportNavaids(option, true),()=> this.exportNavaids(option, false));
        }
        break;
      case 'Coordinate Points':
        if(option == 'Selected Coordinate Points to XML'){
         this.exportSelectedCP();
        }
        if(option == 'All Coordinate Points to XML'){
          this.exportAllCP();
        }
        break;
      case 'Procedures':
        if(option == 'Selected Procedures to XML'){
          this.exportSelectedProcedures();
        }
        if(option == 'All Procedures to XML'){
          this.exportAllProcedures();
        }
        break;
      case 'AirSpace Boundaries':
        if(option == 'Selected AirSpace Boundaries to XML') {
          this.exportSelectedAirSpaceBoundariesToXml();
         }
        if(option == 'All AirSpace Boundaries to XML'){
           this.exportAllAirSpaceBoundariesToXml();
        }
        break;
      case 'RFI-Transmitters':
        if (option == 'All RFI-Transmitters to JSON'){
          const blob = new Blob([JSON.stringify(this.deviceService.devices.map(device => device.exportJson()))], { type: 'application/json;charset=utf-8;' });
          fileSaver.saveAs(blob, "RFI_Transmitters.json");
        }
        break;
      case 'Map RFI-Transmitters':
        if (option == 'All RFI-Transmitters to JSON') {
          let features = this.pointsController.getGritFeatures<InterferenceTestDeviceModel>(FeatureType.Device);
          const blob = new Blob([JSON.stringify(features.map(feat => feat.entity).map(device => device.exportJson()))], { type: 'application/json;charset=utf-8;' });
          fileSaver.saveAs(blob, "All_Map_RFI_Transmitters.json");
        }
        else if (option == 'Selected RFI-Transmitters to JSON'){
          let features = await this.pointsController.getGritSelected<InterferenceTestDeviceModel>(FeatureType.Device);
          const blob = new Blob([JSON.stringify(features.map(feat => feat.entity).map(device => device.exportJson()))], { type: 'application/json;charset=utf-8;' });
          fileSaver.saveAs(blob, "Selected_Map_RFI_Transmitters.json");
        }
        break;
      case 'Receivers':
        if (option == 'All Receivers to JSON'){
          const blob = new Blob([JSON.stringify(this.receiverService.receivers.map(receiver => receiver.exportJson()))], { type: 'application/json;charset=utf-8;' });
          fileSaver.saveAs(blob, "Receivers.json");
        }
        break;

    }
    this.bsModalRef.hide();
  }

  private getCSVArrayOfField(navaid:NavaidModel, key):Array<String>{

    let keysOfObjectArray = Object.keys(navaid[key][0]);
    let result = [];
    for(let arrayElem of navaid[key]){
      let line = keysOfObjectArray.map((elemKey) =>arrayElem[elemKey]).join(";") + ";";
      result.push(line);
    }
    return result;
  }
  private duplicateNavaidLines(navaid:NavaidModel, lines:Array<String>, keyOfNavaidField){
    let result: Array<String> = [];
    let arrayCSVOfField = this.getCSVArrayOfField(navaid,keyOfNavaidField);
    for(let i = 0; i < lines.length;i++){
      for(let arrayElem of arrayCSVOfField){
        result.push(lines[i] + ";" + arrayElem);
      }
    }
    return result;
  }

  /*
  exportNavaidsToCSV(navaids :NavaidModel[]){









    let keys = Object.keys(navaids[0]);

    const separator = ";";

    let linesCSV = [];
    let nonArrayFieldKeys = keys.filter((key) => !NavaidModel.objectFieldIsArray(key));
    let arrayFieldKeys = keys.filter((key) => NavaidModel.objectFieldIsArray(key));

    //let header = nonArrayFieldKeys.join(separator)+separator + arrayFieldKeys.join(separator) + separator ;

    for(let navaid of navaids){
      let lineWithoutArrayFields = nonArrayFieldKeys.map((key) => navaid[key]).join(separator) + separator;
      let navaidLines = [];
      navaidLines.push(lineWithoutArrayFields);
      for(let key of arrayFieldKeys){
        if(navaid[key] != null && navaid[key].length > 0){
          navaidLines = this.duplicateNavaidLines(navaid,navaidLines,key);
        }
      }
      linesCSV = linesCSV.concat(navaidLines);
    }
    let csvContent =  header + "\n" + linesCSV.join("\n");
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    fileSaver.saveAs(blob, "navaidFile.csv");
  }
*/
  async exportSelectedNavaidsToXml(includeNavaidFiles: boolean){
    var identifiers = "";
    for await (const element of this.pointsController.getSelectedFeatures()) {
      if(element.getProperties().featureType == 0){//navaid
        identifiers += element.get("id") + ";";
      }
    }
    if(identifiers == ""){
      this.modalService.showMesssageModal("Warning", "Please select at least 1 NavAid to export");
    }
    else{
      this.pointsController.exportNavaidsXMLFile(identifiers,includeNavaidFiles);
    }
  }

  exportAllNavaidsToXml(includeNavaidFiles:boolean){
    if (this.pointsController.getAllNavaidsFeaturesFromLayers().length == 0){
      this.modalService.showMesssageModal("Warning", "No available NavAids to export");
      return;
    }
    this.pointsController.exportNavaidsXMLFile(null,includeNavaidFiles);
  }

  async exportSelectedAirSpaceBoundariesToXml(){
    var identifiers = "";
    for await (const element of this.pointsController.getSelectedFeatures()) {
      if(element.getProperties().featureType == FeatureType.AirSpaceBoundary){//AirSpaceBoundary
        identifiers += element.get("id") + ";";
      }
    }
    if(identifiers == ""){
      this.modalService.showMesssageModal("Warning", "Please select at least 1 Air Space Boundary to export");
    }
    else{
      await this.pointsController.exportAirSpaceBoundariesXMLFile(identifiers);
    }
  }

  async exportAllAirSpaceBoundariesToXml(){
    if (this.pointsController.getAllAirSpaceBoundaryFeaturesFromLayers().length == 0){
      this.modalService.showMesssageModal("Warning", "No available Air Space Boundaries to export");
      return;
    }
    await this.pointsController.exportAirSpaceBoundariesXMLFile(null);
  }

  async exportSelectedProcedures(){
    var identifiers = "";
    for await (const element of this.pointsController.getSelectedFeatures()) {
      if(element.getProperties().featureType == FeatureType.Procedure){//AirSpaceBoundary
        identifiers += element.get("id") + ";";
      }
    }
    if(identifiers == ""){
      this.modalService.showMesssageModal("Warning", "Please select at least 1 Procedure to export");
    }
    else{
      this.pointsController.exportProceduresXMLFile(identifiers);
    }
  }

  exportAllProcedures(){
    if (this.pointsController.getAllProceduresFeaturesFromLayers().length == 0){
      this.modalService.showMesssageModal("Warning", "No available Procedures to export");
      return;
    }
    this.pointsController.exportProceduresXMLFile(null);
  }

  exportAllCP(){
    if (this.pointsController.getAllCoordinatePointsFeaturesFromLayers().length == 0){
      this.modalService.showMesssageModal("Warning", "No available Coordinate Points to export");
      return;
    }
    this.pointsController.exportCPXMLFile(null);
  }

  async exportSelectedCP(){
    var identifiers = "";
    for await (const element of this.pointsController.getSelectedFeatures()) {
      if(element.getProperties().featureType == 1){//CP
        identifiers += element.get("id") + ";";
      }
    }
    if(identifiers == ""){
      this.modalService.showMesssageModal("Warning", "Please select at least 1 Coordinate Point to export");
    }
    else{
      this.pointsController.exportCPXMLFile(identifiers);
    }
  }

  cancel(){
    this.bsModalRef.hide();
  }

}
